import { gql } from '@apollo/client';

/**
 * Query to fetch current owner details.
 * currentOwner is a top-level root — separate from currentCustomer.
 * Includes contact info, address, and public financial details.
 * Use cache-first since owner data is stable.
 */
export const GET_CURRENT_OWNER_QUERY = gql`
	query getCurrentOwner {
		currentOwner {
			corporateRegistrationNumber
			name
			address {
				city
				country
				postalCode
				road
			}
			contactInformation {
				emailAddress
				phoneNumber
			}
			publicFinancialDetails {
				invoiceBankgiro
				invoicePlusgiro
			}
			vatIdentificationNumber
		}
	}
`;

/**
 * Query to fetch all available customer roles from currentOwner.
 * Supports cursor-based pagination (49 per page).
 * Use cache-first since roles are stable reference data.
 */
export const GET_OWNER_CUSTOMER_ROLES_QUERY = gql`
	query getOwnerCustomerRoles($after: String, $before: String, $first: Int, $last: Int) {
		currentOwner {
			corporateRegistrationNumber
			customerRoles(after: $after, before: $before, first: $first, last: $last) {
				nodes {
					claimName
					description
					displayName
					groupingName
					isApiEditable
				}
				pageInfo {
					endCursor
					hasNextPage
					hasPreviousPage
					startCursor
				}
			}
		}
	}
`;
